import React from "react";
import PropTypes from 'prop-types';

const BreadcrumbComponent = ({breadcrumbs}) => {
    return (
        <ol
            className="breadcrumb breadcrumb-arrows mb-2"
            aria-label="breadcrumbs"
        >
        {breadcrumbs.map((crumb) => {
            return (
            <li key={crumb.link} className="breadcrumb-item">
                <a href={crumb.link}>{crumb.title}</a>
            </li>
            );
        })}
        </ol>
    )
}

export default BreadcrumbComponent;

BreadcrumbComponent.propTypes = {
    breadcrumbs: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string.isRequired,
            link: PropTypes.string.isRequired
        })
    ).isRequired
};